export const ROB_UPDATE_RESET = "ROB_UPDATE_RESET";
export const ROB_UPDATE_SET_UPDATED = "ROB_UPDATE_SET_UPDATED";
export const ROB_UPDATE_SET_ERROR = "ROB_UPDATE_SET_ERROR";
export const ROB_UPDATE_TOGGLE_LOADING = "ROB_UPDATE_TOGGLE_LOADING";
